export default function AboutSection() {
  const rValues = ["R-11", "R-13", "R-15", "R-19", "R-21", "R-30", "R-38"];

  return (
    <section id="about" className="py-14 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-red-600 mb-3 block">
              About Us
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
              Cheapest Insulation <br className="hidden md:block" />
              <strong>In Town. Guaranteed.</strong>
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              We carry brand new batts and rolls fiberglass insulation in a wide range of R-values
              to suit different insulation needs for homes and buildings. Whether you&apos;re insulating
              walls, attics, crawlspaces, or floors — we&apos;ve got you covered at the lowest prices.
            </p>


            {/* R-values */}
            <div className="mb-6">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Available R-Values</p>
              <div className="flex flex-wrap gap-2">
                {rValues.map((r) => (
                  <span
                    key={r}
                    className="bg-[#1a1a2e] text-white text-xs font-bold px-3 py-1 rounded-full"
                  >
                    {r}
                  </span>
                ))}
              </div>
            </div>

            {/* Widths */}
            <div className="flex gap-4 mb-8">
              <div className="bg-gray-50 rounded-lg px-4 py-3 text-center border border-gray-100">
                <p className="text-lg font-bold text-gray-900">16&quot;</p>
                <p className="text-xs text-gray-500">Width</p>
              </div>
              <div className="bg-gray-50 rounded-lg px-4 py-3 text-center border border-gray-100">
                <p className="text-lg font-bold text-gray-900">24&quot;</p>
                <p className="text-xs text-gray-500">Width</p>
              </div>
              <div className="bg-gray-50 rounded-lg px-4 py-3 text-center border border-gray-100">
                <p className="text-lg font-bold text-gray-900">Appt</p>
                <p className="text-xs text-gray-500">Only</p>
              </div>
            </div>

            <a
              href="tel:678-936-5391"
              className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-md font-semibold text-sm hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              Call or Text 678-936-5391
            </a>
          </div>

          {/* Feature cards */}
          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: "ri-price-tag-3-line", title: "Lowest Prices", desc: "Guaranteed cheapest insulation in town — no hidden fees." },
              { icon: "ri-shield-check-line", title: "Brand New Stock", desc: "All products are brand new, never used or reclaimed." },
              { icon: "ri-truck-line", title: "Fresh Truck Loads", desc: "New inventory arrives regularly. Sign up for SMS alerts." },
              { icon: "ri-map-pin-line", title: "Buford, GA 30518", desc: "Conveniently located at 1040 Parkway Industrial Park Drive." },
            ].map((item) => (
              <div key={item.title} className="bg-[#f9f9f7] rounded-lg p-5 border border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg mb-3">
                  <i className={`${item.icon} text-red-600 text-xl`}></i>
                </div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">{item.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
